import { render, staticRenderFns } from "./OnOff.vue?vue&type=template&id=17b030aa&scoped=true&"
import script from "./OnOff.vue?vue&type=script&lang=js&"
export * from "./OnOff.vue?vue&type=script&lang=js&"
import style0 from "./OnOff.vue?vue&type=style&index=0&id=17b030aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b030aa",
  null
  
)

export default component.exports